import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    activeTabByModule: {
        secondary: "",
        agreement: "",
    },
    preserveModuleOnReturn: null,
};

export const activeTabStore = createSlice({
    name: "activeTabStore",
    initialState,
    reducers: {
        loadActiveTabState: (state, action) => {
            const { moduleName, tab } = action.payload;
            state.activeTabByModule[moduleName] = tab;
        },
        setPreserveModuleOnReturn: (state, action) => {
            state.preserveModuleOnReturn = action.payload;
        },
        clearPreserveModuleOnReturn: (state) => {
            state.preserveModuleOnReturn = null;
        },
        resetActiveTabStore: () => initialState,
    },
});

export const {
    loadActiveTabState,
    setPreserveModuleOnReturn,
    clearPreserveModuleOnReturn,
    resetActiveTabStore,
} = activeTabStore.actions;

export default activeTabStore.reducer;